"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoScrollListener = void 0;
var renderer_class_names_1 = require("../../../core/canvas/renderer-class-names");
var dom_1 = require("@devexpress/utils/lib/utils/dom");
var document_renderer_1 = require("../renderes/common/document-renderer");
var AutoScrollListener = (function () {
    function AutoScrollListener(serviceContainer) {
        this.serviceContainer = serviceContainer;
        this.baseFrame = document_renderer_1.DocumentRenderer.renderContainer(renderer_class_names_1.RendererClassNames.AUTO_SCROLL);
        this.top = document_renderer_1.DocumentRenderer.renderContainer(renderer_class_names_1.RendererClassNames.AUTO_SCROLL_CURSOR);
        this.center = document_renderer_1.DocumentRenderer.renderContainer(renderer_class_names_1.RendererClassNames.AUTO_SCROLL_CURSOR);
        this.bottom = document_renderer_1.DocumentRenderer.renderContainer(renderer_class_names_1.RendererClassNames.AUTO_SCROLL_CURSOR);
        dom_1.DomUtils.addClassName(this.top, renderer_class_names_1.RendererClassNames.AUTO_SCROLL_CURSOR_N);
        dom_1.DomUtils.addClassName(this.center, renderer_class_names_1.RendererClassNames.AUTO_SCROLL_CURSOR_NS);
        dom_1.DomUtils.addClassName(this.bottom, renderer_class_names_1.RendererClassNames.AUTO_SCROLL_CURSOR_S);
    }
    AutoScrollListener.prototype.NotifyHide = function () {
        dom_1.DomUtils.hideNode(this.baseFrame);
        dom_1.DomUtils.hideNode(this.top);
        dom_1.DomUtils.hideNode(this.center);
        dom_1.DomUtils.hideNode(this.bottom);
    };
    AutoScrollListener.prototype.NotifyShow = function (_pageIndex, bounds, _tip, _isTextBox, _isAnchoredObject, _rotation) {
        dom_1.DomUtils.setStyleSizeAndPosition(this.baseFrame.style, bounds);
        this.top.style.top = "0px";
        this.top.style.height = bounds.y + "px";
        this.center.style.top = bounds.y + "px";
        this.center.style.height = bounds.height + "px";
        this.bottom.style.top = bounds.bottom + "px";
        this.bottom.style.height = "100%";
        this.serviceContainer.appendChild(this.baseFrame);
        this.serviceContainer.appendChild(this.top);
        this.serviceContainer.appendChild(this.center);
        this.serviceContainer.appendChild(this.bottom);
    };
    AutoScrollListener.HALF_SIZE = 10;
    return AutoScrollListener;
}());
exports.AutoScrollListener = AutoScrollListener;
